import React, { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import DeleteModal from "../../components/atoms/DeleteModal";
import InputGroup from "../../components/atoms/InputGroup";
import Loading from "../../components/atoms/Loading";
import TitleDetail from "../../components/atoms/TitleDetail";
import ModelsDetailHeader from "../../components/deviceModels/ModelsDetailHeader";
import Navbar from "../../components/main/Navbar";
import { ModelsDetailUseContext } from "../../context/AdminDashboard/ModelsDetailContext";
import SensorDetail from "../../components/deviceModels/SensorDetail";
import JsonModal from "../../components/deviceModels/JsonModal";

const ModelsDetail = () => {
  const {
    details,
    loaded,
    sensoreArray,
    onDelete,
    RemoveItem,
    closeDeleteModal,
    getdata,
    showDeleteModal,
    quality,
    showJson,
    closemodal,
    json,
    copyJson,
    onjson,
  } = ModelsDetailUseContext();

  const urlParams = new URLSearchParams(window.location.search);

  useEffect(() => {
    const id = urlParams.get("id");

    getdata(id);
  }, []);

  return (
    <div className="pb-7.5px">
      <Navbar titles={["دستگاه‌ها", "فهرست مدل‌ها", "جزئیات مدل"]} />
      {loaded ? (
        <Loading height={"h-80"} />
      ) : (
        <div
          className="mr-7.5px ml-7.5px mt-5 bg-white shadow-md rounded-sm pr-7.5px pl-7.5px pt-7.5px pb-7.5px"
          dir="rtl">
          <ModelsDetailHeader
            name={details.name}
            deleted={onDelete}
            editto={"/admin/device/models/edit"}
            id={details.id}
            Json={onjson}
          />
          <TitleDetail title={"اطلاعات کلی مدل"} />
          <div className="flex flex-row justify-between w-full gap-5 mt-25">
            <InputGroup
              label={"نام نمایشی"}
              icon={false}
              value={details.name}
              readOnly={true}
            />
            <InputGroup
              label={"شماره سریال"}
              icon={false}
              value={details.serialNumber}
              readOnly={true}
            />
          </div>
          <div className="flex flex-row justify-between w-full gap-5 mt-25">
            <InputGroup
              label={"نام سری"}
              icon={false}
              value={details.seri}
              readOnly={true}
            />
            <InputGroup
              label={"شماره آپدیت"}
              icon={false}
              value={details.updateNumber}
              readOnly={true}
            />
            <InputGroup
              label={"محیط سنجش"}
              icon={false}
              value={details.environment}
              readOnly={true}
            />
            <InputGroup
              label={"نوع استفاده"}
              icon={false}
              value={details.useType}
              readOnly={true}
            />
          </div>
          <div className="flex flex-row justify-between w-full gap-5 mt-25">
            <InputGroup
              label={"نوع سنجش"}
              icon={false}
              value={details.testType}
              readOnly={true}
            />
            <InputGroup
              label={"پروتکل اتصال"}
              icon={false}
              value={details.conectionProtocol}
              readOnly={true}
            />
            <InputGroup
              label={"قوانین بهداشتی"}
              icon={false}
              value={details.HealtRule}
              readOnly={true}
            />
            <InputGroup
              label={"نوع اتصال به برق"}
              icon={false}
              value={details.connectionType}
              readOnly={true}
            />
          </div>
          <div className="flex flex-row justify-between w-full gap-5 mt-25">
            <InputGroup
              label={"وضعیت بلندگو"}
              icon={false}
              value={details.SpeakerStatus}
              readOnly={true}
            />
            <InputGroup
              label={"وضعیت چراغ‌ها‌"}
              icon={false}
              value={details.lightstatus}
              readOnly={true}
            />
            <InputGroup
              label={"وضعیت رِله"}
              icon={false}
              value={details.releStatus}
              readOnly={true}
            />
          </div>
          {sensoreArray.map((jsondata, index) => {
          // console.log(jsondata);
          // console.log(index);
            return (
              <SensorDetail
                key={jsondata.id}
                data={jsondata}
                index={index}
                quality={quality}
              />
            );
          })}
          <Toaster />
          <JsonModal
            showModal={showJson}
            closeModal={closemodal}
            json={json}
            copyJson={copyJson}
          />
          <DeleteModal
            text={`آیا برای حذف مدل “${details.name}” مطمئن هستید؟`}
            showDeleteModal={showDeleteModal}
            closeDeleteModal={closeDeleteModal}
            RemoveItem={RemoveItem}
            title="اخطار حذف اطلاعات"
          />
        </div>
      )}
    </div>
  );
};

export default ModelsDetail;
